import { authedAxios } from "../utils/customHttpHeader";

const sendFeedbackService = async (payload) => {
  const response = await authedAxios().post(
    `/feedback/whatsapp?bookingId=${payload?.bookingId}&hotelId=${payload?.hotelId}`,
  );
  return response;
};

export { sendFeedbackService };
